import { apiClient, assertOk } from "@/api/generated/client.ts"
import type { TagPath } from "@/types/dataPointTypes.ts"

export const getTags = async (req: TagPath): Promise<TagPath[]> => {
  if (!req.historyProvider) {
    const { data, error, response } = await apiClient.GET("/api/Tags")
    return assertOk(response, error, data)
  }

  if (!req.driver) {
    const { data, error, response } = await apiClient.GET("/api/Tags/{provider}", {
      params: { path: { provider: req.historyProvider } },
    })
    return assertOk(response, error, data)
  }

  if (!req.tag) {
    const { data, error, response } = await apiClient.GET("/api/Tags/{provider}/{driver}", {
      params: { path: { provider: req.historyProvider, driver: req.driver } },
    })
    return assertOk(response, error, data)
  }

  const { data, error, response } = await apiClient.GET("/api/Tags/{provider}/{driver}/{path}", {
    params: {
      path: { provider: req.historyProvider, driver: req.driver, path: req.tag },
    },
  })
  return assertOk(response, error, data)
}
